import axios from 'axios'
import { formatTime } from '@/assets/js/bigreport'

const state = {
  dateReport: '',
  lineReport: '',
  lineNameReport: '',
  stationReport: '',
  lineList: [],
  stationList: [],
  tabDiv: 1,
  tabSwitch: false,
  tableSwitch: false,
  tableRow: null
}

const getters = {
  tabDiv (state) {
    return state.tabDiv
  },
  tabSwitch (state) {
    return state.tabSwitch
  },
  tableSwitch (state) {
    return state.tableSwitch
  },
  tableRow (state) {
    return state.tableRow
  },
  dateReport (state) {
    return state.dateReport
  },
  lineReport (state) {
    return state.lineReport
  },
  lineNameReport (state) {
    return state.lineNameReport
  },
  stationReport (state) {
    return state.stationReport
  },
  lineList (state) {
    return state.lineList
  },
  stationList (state) {
    return state.stationList
  }
}
const mutations = {
  tabChange (state, tab) {
    state.tabDiv = tab
  },
  tabSwitchChange (state, tab) {
    state.tabSwitch = tab
  },
  tableSwitchChange (state, tab) {
    state.tableSwitch = tab
  },
  tableRowChange (state, tab) {
    state.tableRow = tab
  },
  //  获取用户prod_line（线别）,prod_station（站位）
  loadUserReport: async function () {
    const data = {
      querySql: 'select usr_user, usr_name, usr_sys_char1, usr_group from dbo.usr_mstr where usr_user = :usr_user and usr_sys_char1 <> :usr_sys_char1 and usr_group <> :usr_group',
      para: {
        usr_user: window.sessionStorage.getItem('currentUserCode'),
        usr_sys_char1: '',
        usr_group: ''
      }
    }
    const { data: res } = await axios.post('/users/getObjects_Slave3', data)
    if (res.data[0]) {
      state.lineReport = res.data[0].usr_group
      state.stationReport = res.data[0].usr_sys_char1
      state.lineNameReport = res.data[0].usr_name
    } else {
      state.lineNameReport = '当前账号无线别信息'
    }
  },
  //  获取线别下拉列表
  loadProdLineList: async function () {
    const para = {
      qu_type: 'dept_list',
      date_type: '',
      column_type: '',
      prod_line: '',
      prod_date: '',
      prod_station: ''
    }
    const { data: res } = await axios.post('/bigreport/getKanbanLineR03', para)
    if (res.data) {
      state.lineList = res.data
    }
  },
  //  获取线别下拉列表
  loadProdStationList: async function () {
    const para = {
      mapkvdCode: 'STATION_REPORT'
    }
    const { data: res } = await axios.post('/users/getListMapkvdDetUsed', para)
    if (res.data) {
      state.stationList = res.data
    }
  },
  //  获取日期prod_date（判断是否在九点之前）
  loadDateReport () {
    const day = formatTime(new Date(), 'yyyy-MM-dd')
    const d1 = new Date().getTime()
    const d2 = new Date(day + ' 09:00:00').getTime()
    if (d1 < d2) {
      state.dateReport = formatTime(new Date().setDate(new Date().getDate() - 1), 'yyyy-MM-dd')
    } else {
      state.dateReport = day
    }
  }
}
const actions = {
  loadReportData ({ commit }) {
    commit('loadUserReport')
    commit('loadProdLineList')
    commit('loadProdStationList')
    commit('loadDateReport')
  }
}
export default {
  namespaced: true,
  getters,
  mutations,
  actions,
  state
}
